import { initializeFilterComponent } from "./filter-component.js";

initializeFilterComponent({
  pickerSelectors: ["#feature-filter", "#ops-stage-filter"],
  searchInputSelector: "#ops-hub-search",
  resultsQuantitySelector: "#results-count",
  gridItemSelector: ".ops-hub-item.employee-success-stories",
  urlParamMapping: ["feature", "ops-stage"],
  titleClass: "ops-hub-title",
});

// Show/hide "No matches" message for Employee Success Stories
const updateNoResults = () => {
  const items = document.querySelectorAll(
    ".ops-hub-item.employee-success-stories",
  );
  const hasVisible = Array.from(items).some(
    (item) => !item.classList.contains("hidden"),
  );
  const noResults = document.getElementById(
    "employee-success-stories-no-results",
  );

  if (noResults) {
    noResults.classList.toggle("hidden", hasVisible);
  }
};

// Listen for filter changes
document
  .querySelector("#feature-filter")
  ?.addEventListener("change", updateNoResults);
document
  .querySelector("#ops-stage-filter")
  ?.addEventListener("change", updateNoResults);
document.querySelector("#ops-hub-search")?.addEventListener("input", () => {
  setTimeout(updateNoResults, 400); // Match filter-component debounce
});

// Initial check on page load
updateNoResults();
